import { motion } from "framer-motion";

const IMG =
  "https://images.unsplash.com/photo-1573164713988-8665fc963095?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHw0fHxhZHZpc29yeSUyMG1lZXRpbmd8ZW58MHx8fHwxNzg1NDEwMjEyfDA&ixlib=rb-4.1.0&q=85";

export const About = () => {
  return (
    <section id="about" data-testid="about-section" className="w-full">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="bg-[#14213D] text-white px-6 lg:px-16 py-20 lg:py-28 flex items-center">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="max-w-xl"
          >
            <p className="label-tech !text-[#8B93B8] mb-10">How we work</p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-[0.98] mb-8">
              Your Extended Team: Financial Experts at fractional costs
            </h2>
            <p className="text-[#AEB6CE] text-lg leading-relaxed max-w-md">
              We become an extension of your finance team with dedicated professionals — providing expert bookkeeping and tax preparation, proactive communication, and the confidence to focus on what matters most: growing your business.
            </p>
          </motion.div>
        </div>

        <div className="min-h-[360px] lg:min-h-0">
          <img src={IMG} alt="Advisor reviewing financials" className="w-full h-full object-cover" />
        </div>
      </div>
    </section>
  );
};
